import { render, staticRenderFns } from "./ConfigIndex.vue?vue&type=template&id=9a22f2fe&"
import script from "./ConfigIndex.vue?vue&type=script&lang=js&"
export * from "./ConfigIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a22f2fe')) {
      api.createRecord('9a22f2fe', component.options)
    } else {
      api.reload('9a22f2fe', component.options)
    }
    module.hot.accept("./ConfigIndex.vue?vue&type=template&id=9a22f2fe&", function () {
      api.rerender('9a22f2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/portal-cebas/credentialing/ConfigIndex.vue"
export default component.exports